// Popup.tsx
import React, { useEffect } from "react";
import {  useForm } from "react-hook-form";
import deletemodelpopup from "../../assets/dashboard/deletemodelpopup.svg";
import deletemodelAnimatedicon from "../../assets/dashboard/meeting-delete-img.gif";

interface DeleteMeetingProps {
  isOpen: boolean;
  onClose: () => void;
  date: string;
  onsubmit: any;
  isDelete:any
}

const DeleteMeeting: React.FC<
  DeleteMeetingProps
> = ({ isOpen, onClose, date, onsubmit, isDelete }) => {
  const { control, handleSubmit } = useForm();

  useEffect(() => {
    document.body.classList.add("coverflow_hidden_scoll_bdy");

    return () => {
      document.body.classList.remove("coverflow_hidden_scoll_bdy");
    };
  }, []);

  if (!isOpen) return null;
  

  return (
    <section id="model-main-blg">
      <div id="inner_loader_dv">
        <div className="w-[622px] flex flex-row items-start justify-start max-w-[622px] z-[1] mq825:max-w-full m-4 schedularaddmeeting_main">
          <form
            onSubmit={handleSubmit(onsubmit)}
            className="responsive-model-popup-dv bg-white m-0 flex-1 rounded-radius-radius-lg border-[1px] border-solid border-surface-border flex flex-col items-center justify-start p-8 mq575:p-3 box-border gap-[23.8px] max-w-full mq825:pt-[21px] mq825:pb-[21px] mq825:box-border"
          >
            <div className="p-0 mq575:p-0 min-w-full relative">
              <div className="flex justify-start items-center relative">
              <img src={deletemodelAnimatedicon} className="w-9 h-9 mq575:w-10 mq575:h-10 relative left-[-7px]" alt="" />
                <div className="flex justify-between w-full items-center relative left-[-7px]">
                  <h2 className=" mb-0 my-0 font-bold text-xl-dv text-black dark:text-white">Delete Meeting?</h2>
                
                <div   onClick={onClose} className="text-gray-400 flex justify-center w-[25px] h-[25px] cta-red transition mt-0.5 ml-4 flex-shrink-0 pt-1">
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path></svg>
                </div>
                </div>
                {/* <img
                  src={deletemodelpopup}
                  alt=""
                  className="cursor-pointer absolute closeicon-model right-0 dark-white-img"
                  style={{ width: "20px", height: "20px" }}
                
                /> */}
              </div>
              <div className="">
                <div className="grid items-center justify-start gap-[16px] py-5">
                  {/* <div className="min-w-full flex justify-center ">
                   
                  </div> */}
                  <div className="block text-center">
                    <span className="text-base font-bold">
                      Are you sure you want to delete this meeting?
                    </span>
                  </div>
                </div>
                <div className="self-stretch flex flex-row items-center justify-end py-0 pr-0 gap-[8px] mq450:box-border mq950:box-border mq1425:flex-wrap mq1425:box-border min-w-full">
                  <button
                    onClick={onClose}
                    type="button"
                    className="cursor-pointer py-2.5 px-[42px]  h-[45px] mq575:h-[35px] mq575:py-[12.5px] mq575:px-[25px] bg-surface-bg-primary bg-white rounded-radiuscomponent-button box-border flex flex-row items-center justify-center gap-[12px] min-w-[88px] border-[2px] border-solid border-surface-primary-surface hover:bg-gainsboro-100 hover:box-border hover:border-[2px] hover:border-solid hover:border-dodgerblue"
                  >
                    <div className="relative text-sm font-body-xs-semi-bold text-surface-primary-surface text-center inline-block ">
                      No
                    </div>
                  </button>
                  <button
                    type="submit"
                    className={`cursor-pointer [border:none] py-2.5 px-[42px]  h-[45px] mq575:h-[35px] mq575:py-[12.5px] mq575:px-[25px] bg-surface-primary-surface rounded-radiuscomponent-button flex flex-row items-center justify-center gap-[12px] hover:bg-dodgerblue ${isDelete == true ? "modeldelete_btn_dv" : ""}`}
                  >
                    <div className="relative text-sm font-body-xs-semi-bold text-surface-bg-primary text-center inline-block ">
                      Yes
                    </div>
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </section>
  );
};

export default DeleteMeeting;
